import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { AccessService } from '../../core/services/access.service';
import { AristotleBrandData } from 'src/app/audience/targeting/aristotle-brand/aristotle-brand.interface';
import { tap } from 'rxjs/operators';
import { FileService } from './file.service';

@Injectable({
  providedIn: 'root',
})
export class EflowService {
  public baseUrl = environment.nestEflowApiUrl;

  constructor(
    private http: HttpClient, // private errorHandlerService: ErrorHandlerService
    private accessApi: AccessService,
    private fileService: FileService,
  ) {}

  private httpOptions: { headers: HttpHeaders } = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  get(url, params = {}, options = {}): Observable<any> {
    const queryString =
      url.indexOf('?') == -1 && !_.isEmpty(params)
        ? '?' + new URLSearchParams(params).toString()
        : '';
    return this.http.get(
      `${environment.nestEflowApiUrl}${url}${queryString}`,
      options,
    );
  }
  post(url, params): Observable<any> {
    return this.http.post(`${environment.nestEflowApiUrl}${url}`, params);
  }
  put(url, params): Observable<any> {
    return this.http.put(`${environment.nestEflowApiUrl}${url}`, params);
  }
  patch(url, params): Observable<any> {
    return this.http.patch(`${environment.nestEflowApiUrl}${url}`, params);
  }
  delete(url, params): Observable<any> {
    return this.http.delete(`${environment.nestEflowApiUrl}${url}`, params);
  }
  getAllCustomers(): Observable<any> {
    return this.get('/elevate/allCustomers');
  }
  getActiveCustomers(): Observable<any> {
    return this.http.get(
      `${environment.nestElevationApiUrl}/elevate/activeCustomers`,
    );
  }
  getMyCustomers(user): Observable<any> {
    return this.http.post(
      `${environment.nestElevationApiUrl}/access/myCustomers`,
      _.pick(user, ['user_uuid', 'groups', 'user_info']),
    );
  }
  getActiveCustomerByCbr(cbr_uuid): Observable<any> {
    return this.http.get(
      `${environment.nestElevationApiUrl}/elevate/activeCustomerByCbr?cbr_uuid=${cbr_uuid}`,
    );
  }

  getAllDealers(gvars?): Observable<any> {
    const params = _.map(
      {
        limit: 10,
        offset: 0,
        cols: 'dealer_uuid,name,state,website,brands,city,zip,geocode',
        ...gvars,
      },
      (d, k) => {
        return `${k}=${d}`;
      },
    ).join('&');
    return this.http.get(`${this.baseUrl}/alldealers?${params}`);
  }

  getAllDealersByZip(gvars?): Observable<any> {
    const params = _.map({ ...gvars }, (d, k) => {
      return `${k}=${d}`;
    }).join('&');
    return this.http.get(
      `${this.baseUrl}/alldealers/getAllDealersByZip?${params}`,
    );
  }

  getRobomailTargetResponseReport(vipcode): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/robomail/getRobomailTargetResponseReport?vipcode=${vipcode}`,
    );
  }

  getTrackerCampaignLinks(vipcode): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/robomail/getTrackerCampaignLinks?vipcode=${vipcode}`,
    );
  }

  getRobomailBroadcastReport(vipcode): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/robomail/getRobomailBroadcastReport?vipcode=${vipcode}`,
    );
  }

  /*CrissCross / YellowPages Stuff*/
  loadCrissCrossYellowPages(account_num): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/criss-cross/loadCrissCrossYellowPages?account_num=${account_num}`,
    );
  }
  async loadYellowPagesByCbrUuid(cbr_uuids): Promise<any> {
    for (const cbr_uuid of cbr_uuids) {
      await this.http
        .get(
          `${this.baseUrl}/criss-cross/loadYellowPagesByCbrUuid?cbr_uuid=${cbr_uuid}`,
        )
        .toPromise();
    }
    return;
  }

  //Dealer ProvidedStuff
  async getDealerProvidedStatusSummary(): Promise<any> {
    return this.http
      .get(
        `${environment.nestElevationApiUrl}/dealer-provided/getDealerProvidedStatusSummary`,
      )
      .toPromise();
  }

  getDealerProvidedFiles(): Observable<any> {
    return this.http.get(
      `${environment.nestElevationApiUrl}/dealer-provided/getDealerProvidedFiles`,
    );
  }
  getDealerProvidedFileRecords(dp_file_uuid): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/dealer-provided/getDealerProvidedFileRecords?dp_file_uuid=${dp_file_uuid}`,
    );
  }

  async getDealerProvidedStatusByAccount(account_num): Promise<any> {
    return this.http
      .get(
        `${environment.nestElevationApiUrl}/dealer-provided/getDealerProvidedStatusByAccount?account_num=${account_num}`,
      )
      .toPromise();
  }

  getOriginalDpFile(egi_filename, original_filename) {
    // const url = 'https://egi-api.epiphanex.com/omt/export/' + filename + '?export_type=suppression_export&list_type=suppression&account_num='+this.accountNum+'&campaign_key='+this.campaignKey+'&dco_site_id=1&auth_key=629ea048ef635147a565f76a116ed3cc';
    //const url = `${this.baseUrl}/dealer-provided/downloadCsv?filename=${egi_filename}`;
    const url = `${this.baseUrl}/dealer-provided/downloadOriginal?filename=${egi_filename}&original_filename=${original_filename}`;
    window.open(url, '_self');

    //return this.http.get(`${this.baseUrl}/dealer-provided/downloadCsv?filename=${egi_filename}`).toPromise();
  }

  sendDealerProvidedToRobomail(dp_file_uuid): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/robomail/sendDealerProvidedList?dp_file_uuid=${dp_file_uuid}`,
    );
  }
  //Brand Marketing Stuff
  getBrandMarketingSummary(): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/brand-marketing/getBrandMarketingSummary`,
    );
  }

  getBrandMarketingFileSummary(filename): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/brand-marketing/getBrandMarketingFileSummary?filename=${filename}`,
    );
  }

  getBrandMarketingFileRecords(
    filename,
    auto_make_code,
    auto_year,
  ): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/brand-marketing/getBrandMarketingFileRecords?filename=${filename}&auto_make_code=${auto_make_code}&auto_year=${auto_year}`,
    );
  }

  processDailyLoadByAccountAfterDate(account_num, start_date): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/dms/processDailyLoadByAccountAfterDate?account_num=${account_num}&start_date=${start_date}`,
    );
  }

  //Recalls

  getCbrRecalls(cbr_uuid): Observable<any> {
    return this.get(`/recalls/getCbrRecalls?cbr_uuid=${cbr_uuid}`);
  }

  getUsedCarRecallReport(cbr_uuid): Observable<any> {
    return this.get(`/recalls/getUsedCarRecallReport?cbr_uuid=${cbr_uuid}`);
  }

  getRecallSniperSummaryReport(): Observable<any> {
    return this.http.get(
      `${environment.nestElevationApiUrl}/recalls/getRecallSniperSummaryReport`,
    );
  }

  updateUsedCarRecall(vin, url_data): Observable<any> {
    return this.http.put(`/recalls/updateUsedCarRecall`, {
      vin,
      url_data,
    });
  }

  getData(url, data?, options?): Observable<any> {
    const qStr = data
      ? '?' +
        _.map(data, (d, k) => {
          return `${k}=${d}`;
        }).join('&')
      : '';
    return this.http.get(`${this.baseUrl}${url}${qStr}`, options);
  }

  postData(url, body = {}, data?, options?): Observable<any> {
    const qStr = data
      ? '?' +
        _.map(data, (d, k) => {
          return `${k}=${d}`;
        }).join('&')
      : '';
    return this.http.post(`${this.baseUrl}${url}${qStr}`, body, options);
  }

  getRecallsByAccountVds(account_num, wmi_vds): Observable<any> {
    return this.post(`/recalls/getRecallsByAccountVds`, {
      account_num,
      wmi_vds,
    });
  }

  refreshMatchingReportsAll(): Observable<any> {
    return this.get(`/matching/refreshMatchingReportsAll`);
  }
  refreshDmsEofAll(): Observable<any> {
    return this.get(`/dms/refreshDmsEofAll`);
  }
  refreshDmsEofByAccount(account_num): Observable<any> {
    return this.get(`/dms/refreshDmsEofByAccount?account_num=${account_num}`);
  }
  loadCrissCrossEstimate(account_num): Observable<any> {
    return this.get(
      `/criss-cross/loadCrissCrossEstimate?account_num=${account_num}&num_months=12&max_distance=60&zip_by_closest_competitor=3&num_neighbors=20&include_sales=1&include_service=0`,
    );
  }
  queueMatching(account_num): Observable<any> {
    return this.patch(`/matching/queueMatching?account_num=${account_num}`, {});
  }
  queueMatchingAll(): Observable<any> {
    return this.patch(`/matching/queueMatchingAll`, {});
  }
  loadYellowPagesToMarketing(
    account_num,
    limit = 12000,
    email_append = false,
  ): Observable<any> {
    const to = this.accessApi?.user?.email;
    return this.get('/criss-cross/loadYellowPagesToMarketing', {
      account_num,
      limit,
      email_append,
      to,
    });
  }
  loadYellowPagesMonthly() {
    return this.get(`/criss-cross/loadYellowPagesMonthly`);
  }
  loadCrissCrossMonthly(): Observable<any> {
    return this.get(`/criss-cross/loadCrissCrossMonthly`);
  }
  startDailyLoad(): Observable<any> {
    return this.get(`/dms/startDailyLoad`);
  }
  completeDailyLoad(): Observable<any> {
    return this.get(`/dms/completeDailyLoad`);
  }
  refreshCatalogData(catalog_id): Observable<any> {
    return this.get(
      `/facebook/requestProductFeedUpdate?catalog_id=${catalog_id}`,
    );
  }

  getOmtServiceResult(
    account_num,
    campaign_key,
    full_report,
    start_date,
    end_date,
  ): Observable<any> {
    return this.get(
      `/reporting/getOmtServiceResult?account_num=${account_num}&campaign_key=${campaign_key}&full_report=${full_report}&start_date=${start_date}&end_date=${end_date}`,
    );
  }

  getServiceCampaignInfo(account_num): Observable<any> {
    return this.get(
      `/reporting/getServiceCampaignInfo?account_num=${account_num}`,
    );
  }

  getSalesCampaignInfo(account_num): Observable<any> {
    return this.get(
      `/reporting/getSalesCampaignInfo?account_num=${account_num}`,
    );
  }

  getReportingMonthlyTotal(
    account_num,
    start_date,
    end_date,
    full_report,
  ): Observable<any> {
    return this.get(
      `/reporting/getMonthlyTotal?account_num=${account_num}&start_date=${start_date}&end_date=${end_date}&full_report=${full_report}`,
    );
  }

  getServiceGraphs(account_num, start_date, end_date): Observable<any> {
    return this.get(
      `/reporting/getServiceGraphData?account_num=${account_num}&start_date=${start_date}&end_date=${end_date}`,
    );
  }

  getSalesGraphs(account_num, start_date, end_date): Observable<any> {
    return this.get(
      `/reporting/getSalesGraphData?account_num=${account_num}&start_date=${start_date}&end_date=${end_date}`,
    );
  }

  getLifetimeService(account_num, end_date, full_report): Observable<any> {
    return this.get(
      `/reporting/getLifetimeService?account_num=${account_num}&end_date=${end_date}&full_report=${full_report}`,
    );
  }

  getLifetimeSales(account_num, end_date, full_report): Observable<any> {
    return this.get(
      `/reporting/getLifetimeSales?account_num=${account_num}&end_date=${end_date}&full_report=${full_report}`,
    );
  }

  getOmtSalesResult(
    account_num,
    campaign_key,
    full_report,
    start_date,
    end_date,
  ): Observable<any> {
    return this.get(
      `/reporting/getOmtSalesResult?account_num=${account_num}&campaign_key=${campaign_key}&full_report=${full_report}&start_date=${start_date}&end_date=${end_date}`,
    );
  }

  getAverageRO(account_num, start_date, end_date): Observable<any> {
    return this.get(
      `/reporting/getAverageRO?account_num=${account_num}&start_date=${start_date}&end_date=${end_date}`,
    );
  }

  getOpCodeReport(account_num, start_date, end_date): Observable<any> {
    return this.get(
      `/reporting/getOpsCodeReport?account_num=${account_num}&start_date=${start_date}&end_date=${end_date}`,
      { responseType: 'blob' },
    );
  }

  updateTargetCounts(account_num): Observable<any> {
    return this.get(`/elevate/updateTargetCounts?account_num=${account_num}`);
  }
  refreshMatchingReports(account_num): Observable<any> {
    return this.get(
      `/matching/refreshMatchingReports?account_num=${account_num}`,
    );
  }
  updateMatchingTypeReport(account_num): Observable<any> {
    return this.get(
      `/targeting/updateMatchingTypeReport?account_num=${account_num}`,
    );
  }
  sendMarketingListToRobomail(account_num): Observable<any> {
    return this.get(`/robomail/sendMarketingList?account_num=${account_num}`);
  }

  sendMasterSalesServiceList(account_num): Observable<any> {
    return this.get(
      `/robomail/sendMasterSalesServiceList?account_num=${account_num}`,
    );
  }

  campaignExport(paged_params, gvars): Observable<any> {
    /**
     *   list_type,
    data_table_parameters,
    account_num,
    campaign_key,
    offset,
    limit,
     */
    const params = _.map(gvars, (d, k) => {
      return `${k}=${d}`;
    }).join('&');
    return this.get(
      `/targeting/campaignExport?${params}&columns=${paged_params.columns}&draw=${paged_params.draw}&length=${paged_params.length}&order=${paged_params.order}&search=${paged_params.search}&start=${paged_params.start}`,
      undefined,
      { headers: new HttpHeaders({ timeout: '90000' }) },
    );
  }
  campaignExportFile(gvars): Observable<any> {
    return this.get('/targeting/campaignExportFile', gvars, {
      responseType: 'blob',
      observe: 'response',
      headers: new HttpHeaders({ timeout: '120000' }),
    }).pipe(
      tap((response: HttpResponse<Blob>) =>
        this.fileService.downloadCsvFileFromResponse(response),
      ),
    );
  }

  createPDF(baseurl, url, name): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/pdf/generate`,
      JSON.stringify({
        baseurl,
        url,
        name,
      }),
      {
        responseType: 'blob',
      },
    );
  }

  createPDFDiv(baseurl, url, div, dealer): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/pdf/generate-div`,
      JSON.stringify({
        baseurl,
        url,
        div,
        dealer,
      }),
      {
        responseType: 'blob',
      },
    );
  }

  getYoYMonthlySales(account_num, start_date, end_date): Observable<any> {
    return this.get(
      `/graphs/yoy-monthly-comparison?account_num=${account_num}&start_date=${start_date}&end_date=${end_date}`,
    );
  }

  getEdificeYoYMonthlySales(
    account_num,
    start_date,
    end_date,
  ): Observable<any> {
    return this.get(
      `/graphs/edifice-yoy-monthly-comparison?account_num=${account_num}&start_date=${start_date}&end_date=${end_date}`,
    );
  }

  createCreator(
    name: string,
    template: boolean,
    dealer_num: string,
    data: any,
    auth_key: string,
  ): Observable<any> {
    data = cleanDataCreator(data);
    return this.http.post(`${this.baseUrl}/creator`, {
      name,
      template,
      dealer_num,
      data,
      auth_key,
    });
  }

  getCreator(id: number): Observable<any> {
    return this.get(`/creator?id=${id}`);
  }

  getAllCreator(): Observable<any> {
    return this.get(`/creator/all`);
  }

  getCreatorTemplates(): Observable<any> {
    return this.get(`/creator/templates`);
  }

  updateCreator(
    id: number,
    name: string,
    template: boolean,
    dealer_num: string,
    data: any,
    auth_key: string,
  ): Observable<any> {
    data = cleanDataCreator(data);
    return this.http.put(`${this.baseUrl}/creator/update`, {
      report_id: id,
      name: name,
      template: template,
      dealer_num: dealer_num,
      auth_key: auth_key,
      data: data,
    });
  }

  deleteCreator(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/creator/delete?id=${id}`);
  }

  getCreatorPage(id: number, page: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/creator/page?id=${id}&page=${page}`);
  }

  printCreator(baseurl: string, url: string, name: string): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/creator/print`,
      JSON.stringify({
        baseurl: baseurl,
        url: url,
        name: name,
      }),
      {
        responseType: 'blob',
      },
    );
  }

  getOverallRoi(
    account_num,
    start_date,
    end_date,
    match_type,
  ): Observable<any> {
    return this.get(
      `/kpi/overall-roi?account_num=${account_num}&start_date=${start_date}&end_date=${end_date}&match_type=${match_type}`,
    );
  }

  getTargetList(
    paged_params,
    campaign_key,
    vipcode,
    list_type,
  ): Observable<any> {
    return this.get(
      `/targeting/getTargetList?campaign_key=${campaign_key}&vipcode=${vipcode}&list-type=${list_type}&columns=${paged_params.columns}&draw=${paged_params.draw}&length=${paged_params.length}&order=${paged_params.order}&search=${paged_params.search}&start=${paged_params.start}`,
    );
  }

  getDailyLoadPartitionFileByAccount(
    account_num,
    partition_date,
  ): Observable<any> {
    return this.get(
      `/dms/getDailyLoadPartitionFilesByAccount?account_num=${account_num}&partition_date=${partition_date}`,
      { responseType: 'arraybuffer' },
    );
  }

  sendMatchitMissing(matchitData: {
    account_num: string;
    cutoff_date: string;
    limit: number;
  }): Observable<any> {
    return this.http.post(`${this.baseUrl}/mi/sendJobRequest`, matchitData, {
      headers: { timeout: '300000' },
    });
  }

  getDealerTargetList(filters): Observable<any> {
    return this.get(
      `/dealer-targeting/getDealerTargetList?filters=${JSON.stringify(
        filters,
      )}`,
    );
  }
  getDealerTargetLists(): Observable<any> {
    return this.get(`/dealer-targeting/getLists`);
  }
  sendInternalDealerList(body): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/dealer-targeting/sendInternalList`,
      body,
    );
  }

  getAutoMakesModelsVLO(aristotleData: AristotleBrandData): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/vlo/getVloAutoMakesModels`,
      aristotleData,
    );
  }

  queryAndCountVloAuto(aristotleData: AristotleBrandData): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/vlo/queryAndCountVloAuto`,
      aristotleData,
    );
  }
  sendToKristin(aristotleData: AristotleBrandData): Observable<any> {
    return this.http.post(`${this.baseUrl}/vlo/sendToKristin`, aristotleData);
  }
  uploadAristotleFile(formData: FormData): Observable<any> {
    return this.http.post(`${this.baseUrl}/vlo/uploadFile`, formData);
  }
  getMatchitCutoff(account_num): Observable<any> {
    return this.get(`/mi/getMostRecentLoadDate?account_num=${account_num}`);
  }
  uploadDpFile(formData: FormData): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/dealer-provided/uploadFile`,
      formData,
    );
  }
  getMailingTotals(): Observable<any> {
    return this.http.get(`${this.baseUrl}/robomail/getMailingTotals`);
  }
  getBodyFileInfo(): Observable<any> {
    return this.http.get(`${this.baseUrl}/robomail/getBodyFileInfo`);
  }
  getTunnelRunningCampaigns(): Observable<any> {
    return this.http.get(`${this.baseUrl}/robomail/getTunnelRunningCampaigns`);
  }
  getTunnelCampaigns(): Observable<any> {
    return this.http.get(`${this.baseUrl}/robomail/getTunnelCampaigns`);
  }
  getDailyTotals(): Observable<any> {
    return this.http.get(`${this.baseUrl}/robomail/getDailyTotals`, {
      headers: { timeout: '90000' },
    });
  }
  getHourlyTotalsAll(): Observable<any> {
    return this.http.get(`${this.baseUrl}/robomail/getHourlyTotalsAll`, {
      headers: { timeout: '90000' },
    });
  }
  getDailyTotalsAll(): Observable<any> {
    return this.http.get(`${this.baseUrl}/robomail/getDailyTotalsAll`, {
      headers: { timeout: '90000' },
    });
  }
  getDailyYMTotals(): Observable<any> {
    return this.http.get(`${this.baseUrl}/robomail/getDailyYMTotals`, {
      headers: { timeout: '90000' },
    });
  }
  getDailyGMTotals(): Observable<any> {
    return this.http.get(`${this.baseUrl}/robomail/getDailyGMTotals`, {
      headers: { timeout: '90000' },
    });
  }
  getDailyHMTotals(): Observable<any> {
    return this.http.get(`${this.baseUrl}/robomail/getDailyHMTotals`, {
      headers: { timeout: '90000' },
    });
  }
  getDailyOTTotals(): Observable<any> {
    return this.http.get(`${this.baseUrl}/robomail/getDailyOTTotals`, {
      headers: { timeout: '90000' },
    });
  }
  getRunningBodyFilesOnTunnel(): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/robomail/getRunningBodyFilesOnTunnel`,
    );
  }

  getRunningTunnelsSummary(): Observable<any> {
    return this.http.get(`${this.baseUrl}/robomail/getRunningTunnelsSummary`);
  }
  getMailProviderTunnels(): Observable<any> {
    return this.http.get(`${this.baseUrl}/robomail/getMailProviderTunnels`);
  }

  getMailProviderReport(): Observable<any> {
    return this.http.get(`${this.baseUrl}/robomail/getMailProviderReport`);
  }

  getRunningBodyFile(): Observable<any> {
    return this.http.get(`${this.baseUrl}/robomail/getRunningBodyFile`);
  }
  getRunningCampaignInfo(): Observable<any> {
    return this.http.get(`${this.baseUrl}/robomail/getRunningCampaignInfo`);
  }

  getTunnelThroughput(): Observable<any> {
    return this.http.get(`${this.baseUrl}/robomail/getTunnelThroughput`);
  }
  getRobomailCampaignResults(): Observable<any> {
    return this.http.get(`${this.baseUrl}/robomail/getRobomailCampaignResults`);
  }
  exportRobomailCampaignResults(): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/robomail/exportRobomailCampaignResults`,
      {
        responseType: 'blob',
        observe: 'response',
      },
    );
  }
  getTunnelSuccessDeferral(): Observable<any> {
    return this.http.get(`${this.baseUrl}/robomail/getTunnelSuccessDeferral`);
  }
  exportTunnelSuccessDeferral(): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/robomail/exportTunnelSuccessDeferral`,
      {
        responseType: 'blob',
        observe: 'response',
      },
    );
  }
  getPreviousWeekResults(): Observable<any> {
    return this.http.get(`${this.baseUrl}/robomail/getPreviousWeekResults`);
  }
  exportPreviousWeekResults(): Observable<any> {
    return this.http.get(`${this.baseUrl}/robomail/exportPreviousWeekResults`, {
      responseType: 'blob',
      observe: 'response',
    });
  }
  getInactiveTunnels(): Observable<any> {
    return this.http.get(`${this.baseUrl}/robomail/getInactiveTunnels`);
  }
  exportInactiveTunnels(): Observable<any> {
    return this.http.get(`${this.baseUrl}/robomail/exportInactiveTunnels`, {
      responseType: 'blob',
      observe: 'response',
    });
  }
  getAsanaCreativePriority(): Observable<any> {
    return this.http.get(`${this.baseUrl}/robomail/getAsanaCreativePriority`);
  }
  resendRobomailCampaign(
    mail_provider,
    vipcode,
    throttle_per_hour,
    num_days,
    hours_to_wait,
    test,
    send_rate_type,
  ): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/robomail/resendRobomailCampaign?mail_provider=${mail_provider}&vipcode=${vipcode}&throttle_per_hour=${throttle_per_hour}&num_days=${num_days}&hours_to_wait=${hours_to_wait}&test=${test}&send_rate_type=${send_rate_type}`,
    );
  }
}

export function cleanDataCreator(data) {
  //makes sure data can be stored in database
  data = _.cloneDeep(data);
  data.forEach((grid) => {
    grid.forEach((item) => {
      for (const key in item.data) {
        if (key == 'chartConfig') delete item.data[key];
      }
    });
  });
  return data;
}
